export default "__VITE_ASSET__BtU3ts3m__"